import createFlags from 'flag';

/**
 * The flags are connected in AppContainer.js and is used to feature
 * toggle the react components. The redux state will not be hidden
 * behind feature flags.
 * https://github.com/garbles/flag
 *
 */
const { FlagsProvider, Flag, useFlag, useFlags } = createFlags();
export { FlagsProvider, Flag, useFlag, useFlags };
